import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import appointmentAPI from '../../sources/api/appointmentAPI';

// constants
import { APPOINTMENT_CREATE } from '../../constants/appointmentTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { appointmentSchema } from '../../schemas/Normalizr';

export function* appointmentCreate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(APPOINTMENT_CREATE, call(appointmentAPI.create, params), appointmentSchema);
  } catch (e) {
    yield put(error(APPOINTMENT_CREATE, e));
  } finally {
    yield put(doneIndicator(APPOINTMENT_CREATE));
  }
}

export function* watchAppointmentCreate() {
  yield takeEvery(APPOINTMENT_CREATE, appointmentCreate);
}

export default function* root() {
  yield all([
    fork(watchAppointmentCreate)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/appointment/appointmentCreate.js